import logoFooter from "../../../assets/images/logo-footer.png";
import logoHeader from "../../../assets/images/logo-header.png";
import { StyledLogo } from "../../styled/commons";

/** Logotipo oficial de Access Informática. */
const Logo = ({ light = false }) => (
  <StyledLogo.Wrapper light={light}>
    <img
      src={light ? logoFooter : logoHeader}
      alt="Access Informática"
      width={light ? 150 : 190}
      height={light ? 50 : 44}
    />
  </StyledLogo.Wrapper>
);

export default Logo;
